import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SuccessModal from './SuccessModal';


const OrderPayPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [quantities, setQuantities] = useState({});
  const [orderData, setOrderData] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);

  // Get order data based on orderId (same logic as ProfileOrderDetails)
  const getOrderData = (id) => {
    const allOrders = [
      {
        id: "#ORD57986418741",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true",
            price: 50.00,
            isPremium: false
          }
        ],
        status: "Placed",
        orderDate: "Ordered on 25 May, 2023 08:30 PM"
      },
      {
        id: "#ORD57986418742",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true",
            price: 50.00,
            isPremium: false
          },
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0b475407c9838c9be07495ac10e54e5567924867?placeholderIfAbsent=true",
            price: 50.00,
            isPremium: true
          }
        ],
        status: "Shipped",
        orderDate: "Ordered on 26 May, 2023 09:30 PM"
      },
      {
        id: "#ORD57986418743",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true",
            price: 50.00,
            isPremium: false
          },
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0b475407c9838c9be07495ac10e54e5567924867?placeholderIfAbsent=true",
            price: 50.00,
            isPremium: true
          }
        ],
        status: "Placed",
        orderDate: "Ordered on 27 May, 2023 10:30 PM"
      },
      {
        id: "#ORD57986418744",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true",
            price: 50.00,
            isPremium: false
          }
        ],
        status: "Delivered",
        orderDate: "Ordered on 20 May, 2023 07:30 PM",
        deliveredDate: "22 May, 2023",
        returnDate: "30 May, 2023"
      },
      {
        id: "#ORD57986418745",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0b475407c9838c9be07495ac10e54e5567924867?placeholderIfAbsent=true",
            price: 50.00,
            isPremium: true
          }
        ],
        status: "Delivered",
        orderDate: "Ordered on 18 May, 2023 06:30 PM",
        deliveredDate: "20 May, 2023",
        returnDate: "28 May, 2023"
      },
      {
        id: "#ORD57986418746",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true",
            price: 50.00,
            isPremium: false
          }
        ],
        status: "Returned",
        orderDate: "Ordered on 15 May, 2023 05:30 PM",
        returnedDate: "25 May, 2023"
      }
    ];

    const fullOrderId = `#${orderId}`;
    return allOrders.find(order => order.id === fullOrderId) || allOrders[0];
  };

  // Initialize order data and quantities
  useEffect(() => {
    const fetchedOrderData = getOrderData(orderId);
    setOrderData(fetchedOrderData);

    // Initialize quantities from the original order data
    const initialQuantities = {};
    fetchedOrderData.items.forEach((item, index) => {
      const itemId = `${item.name}_${index}_${item.image}`;
      initialQuantities[itemId] = item.quantity;
    });
    setQuantities(initialQuantities);
  }, [orderId]);

  const handleQuantityChange = (itemId, change) => {
    setQuantities(prev => ({
      ...prev,
      [itemId]: Math.max(1, prev[itemId] + change)
    }));
  };

  const calculateSubTotal = () => {
    if (!orderData) return 0;
    return orderData.items.reduce((total, item, index) => {
      const itemId = `${item.name}_${index}_${item.image}`;
      const quantity = quantities[itemId] || item.quantity;
      return total + (item.price * quantity);
    }, 0);
  };

  const handleProceedToPay = () => {
    // Create new order data with updated quantities
    const newOrderData = {
      originalOrderId: orderData.id,
      items: orderData.items.map((item, index) => {
        const itemId = `${item.name}_${index}_${item.image}`;
        return {
          ...item,
          quantity: quantities[itemId] || item.quantity
        };
      }),
      subTotal: calculateSubTotal(),
      shippingCharge: 50.00,
      total: calculateSubTotal() + 50.00,
      deliveryAddress: {
        name: 'Jaane Cooper',
        address: '4517 Washington Ave. Manchester, Kentucky Preston Rd. Inglewood, 987456',
        phone: '+1 888 3685 368'
      }
    };

    console.log('Processing repeat order:', newOrderData);
    // Show success modal instead of alert
    setShowSuccessModal(true);
  };

  const handleModalClose = () => {
    setShowSuccessModal(false);
    // Navigate back to orders after modal is closed
    navigate('/profile/orders');
  };

  if (!orderData) {
    return <div>Loading...</div>;
  }

  const subTotal = calculateSubTotal();
  const shippingCharge = 50.00;
  const total = subTotal + shippingCharge;

  const QuantityButton = ({ onClick, children, ariaLabel }) => (
    <button
      className="flex justify-center items-center w-6 h-6 rounded-full cursor-pointer bg-sky-950 transition-all duration-200 hover:bg-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );

  const MinusIcon = () => (
    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1H11" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );

  const PlusIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 1V11M1 6H11" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );

  const PremiumIcon = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.91683 12.8333H4.0835C3.84433 12.8333 3.646 12.6349 3.646 12.3958C3.646 12.1566 3.84433 11.9583 4.0835 11.9583H9.91683C10.156 11.9583 10.3543 12.1566 10.3543 12.3958C10.3543 12.6349 10.156 12.8333 9.91683 12.8333Z" fill="#DE5836"/>
      <path d="M11.871 3.21994L9.53763 4.88828C9.22846 5.10994 8.78513 4.97578 8.65096 4.61994L7.54846 1.67994C7.36179 1.17244 6.64429 1.17244 6.45763 1.67994L5.34929 4.61411C5.21513 4.97578 4.77763 5.10994 4.46846 4.88244L2.13513 3.21411C1.66846 2.88744 1.05013 3.34827 1.24263 3.89077L3.66929 10.6866C3.75096 10.9199 3.97263 11.0716 4.21763 11.0716H9.77679C10.0218 11.0716 10.2435 10.9141 10.3251 10.6866L12.7518 3.89077C12.9501 3.34827 12.3318 2.88744 11.871 3.21994ZM8.45846 8.60411H5.54179C5.30263 8.60411 5.10429 8.40578 5.10429 8.16661C5.10429 7.92744 5.30263 7.72911 5.54179 7.72911H8.45846C8.69763 7.72911 8.89596 7.92744 8.89596 8.16661C8.89596 8.40578 8.69763 8.60411 8.45846 8.60411Z" fill="#DE5836"/>
    </svg>
  );

  const EditIcon = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.6016 18.7393H19.2498" stroke="#002347" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.715 3.47856C12.426 2.6288 13.7042 2.5042 14.5715 3.20076C14.6195 3.23854 16.1604 4.43556 16.1604 4.43556C17.1132 5.01159 17.4093 6.23618 16.8203 7.17071C16.789 7.22075 8.07762 18.1174 8.07762 18.1174C7.78779 18.479 7.34785 18.6925 6.87767 18.6976L3.54157 18.7394L2.7899 15.558C2.68461 15.1106 2.7899 14.6408 3.07973 14.2792L11.715 3.47856Z" stroke="#002347" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.1025 5.50085L15.1004 9.33905" stroke="#002347" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <>
      <main className="ml-5 w-[73%] max-md:ml-0 max-md:w-full">
        <div className="flex flex-col flex-1 gap-4 max-md:w-full">
          {/* Header */}
          <div className="mb-4">
            <h1 className="text-2xl font-bold text-sky-950">Repeat Order</h1>
            <p className="text-sm text-gray-600">Order ID: {orderData.id}</p>
          </div>

          {/* Items Section */}
          <section className="p-5 bg-white rounded-2xl shadow-2xl max-sm:p-4">
            <div className="mb-5">
              <h2 className="mb-4 text-lg font-semibold text-black max-sm:text-base">
                Items
              </h2>
              <div className="w-full h-px bg-neutral-300" />
            </div>

            <div className="space-y-2">
              {orderData.items.map((item, index) => {
                const itemId = `${item.name}_${index}_${item.image}`;
                const currentQuantity = quantities[itemId] || item.quantity;

                return (
                  <div key={index} className="flex justify-between items-center px-0 py-2 max-sm:flex-col max-sm:gap-4 max-sm:items-start">
                    <div className="flex gap-3 items-center">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="rounded-md h-[70px] w-[70px] object-cover"
                      />
                      <div className="flex flex-col gap-2">
                        <div className="flex gap-2 items-center text-base font-medium text-sky-950">
                          {item.name}
                          {item.isPremium && (
                            <PremiumIcon />
                          )}
                        </div>
                        <div className="text-sm font-medium text-sky-950">
                          ${item.price.toFixed(2)}
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-6 items-center max-sm:self-end">
                      <QuantityButton
                        onClick={() => handleQuantityChange(itemId, -1)}
                        ariaLabel={`Decrease quantity of ${item.name}`}
                      >
                        <MinusIcon />
                      </QuantityButton>

                      <div
                        className="text-base font-medium text-center text-black min-w-6"
                        aria-label={`Quantity: ${currentQuantity}`}
                      >
                        {currentQuantity}
                      </div>

                      <QuantityButton
                        onClick={() => handleQuantityChange(itemId, 1)}
                        ariaLabel={`Increase quantity of ${item.name}`}
                      >
                        <PlusIcon />
                      </QuantityButton>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

          {/* Delivery Address Section */}
          <section className="p-5 bg-white rounded-2xl shadow-2xl max-sm:p-4">
            <div className="flex justify-between items-center ">
              <h2 className="mb-4 text-lg font-semibold text-black max-sm:text-base">
                Delivery Address
              </h2>
              <button
                className="p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                aria-label="Edit delivery address"
              >
                <EditIcon />
              </button>
            </div>
            <div className="w-full h-px bg-neutral-300" />
            <div className="mt-4">
              <div className="mb-2 text-base font-semibold text-sky-950">
                Jaane Cooper
              </div>
              <address className="mb-1.5 text-base text-black opacity-60 not-italic">
                4517 Washington Ave. Manchester, Kentucky Preston Rd. Inglewood, 987456
              </address>
              <div className="text-sm text-black opacity-60">
                +1 888 3685 368
              </div>
            </div>
          </section>

          {/* Order Summary Section */}
          <section className="p-5 bg-white rounded-2xl shadow-2xl max-sm:p-4">
            <h2 className="mb-4 text-lg font-semibold text-black max-sm:text-base">
              Order Summary
            </h2>
            <div className="w-full h-px bg-neutral-300" />
            <div className="mt-4">
              <div className="flex justify-between items-center mb-3">
                <div className="text-base opacity-90 text-sky-950">
                  Sub total
                </div>
                <div className="text-base font-medium text-sky-950">
                  ${subTotal.toFixed(2)}
                </div>
              </div>
              <div className="flex justify-between items-center mb-3">
                <div className="text-base opacity-90 text-sky-950">
                  Shipping charge
                </div>
                <div className="text-base font-medium text-sky-950">
                  ${shippingCharge.toFixed(2)}
                </div>
              </div>
              <div className="mx-0 my-4 w-full h-px bg-neutral-200" />
              <div className="flex justify-between items-center">
                <div className="text-lg font-semibold text-sky-950">Total</div>
                <div className="text-lg font-semibold text-sky-950">
                  ${total.toFixed(2)}
                </div>
              </div>
            </div>
          </section>

          {/* Proceed & Pay Button */}
          <div className="flex justify-center mt-8">
            <button
              className="px-5 py-3 text-base font-semibold text-center text-white bg-green-500 rounded-2xl shadow-lg cursor-pointer border-none h-[50px] w-[241px] max-sm:w-full transition-all duration-200 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              onClick={handleProceedToPay}
            >
              Proceed &amp; Pay
            </button>
          </div>
        </div>
      </main>

      {/* Success Modal */}
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={handleModalClose}
        title="Toy has been added to your collection"
        message=""
      />
    </>
  );
};

export default OrderPayPage;
